import {Component, OnInit, ViewChild} from '@angular/core';
import {TreeNode} from "primeng/api";
import {OrganizationType} from "../../../model/organization-type";
import {AnalysisCompaniesFilters} from "../../../model/filters/analysis-companies-filters";
import {HierarchyService} from "../../../services/hierarchy.service";
import {OrganizationTypesService} from "../../../services/organization-types.service";
import {OrganizationsService} from "../../../services/organizations.service";
import {AuthGuard} from "../../../common/auth-guard.service";
import {ExportFileType} from "../../../model/export-file-type";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-analysis-companies',
  templateUrl: './analysis-companies.component.html',
  styleUrls: ['./analysis-companies.component.scss']
})
export class AnalysisCompaniesComponent implements OnInit {

  @ViewChild('treeTable')
  public treeTable: any;

  public hierarchy: TreeNode[];
  public hierarchyFilters: TreeNode[];
  public nodes: any;
  public organizationTypes: OrganizationType[];

  public exportVisible: boolean;
  public filtersVisible: boolean;
  public currentFilters: AnalysisCompaniesFilters;

  public organizationParent: any;
  public loadingCompanies: boolean = true;

  public language: string;


  constructor(private hierarchyService: HierarchyService,
              private organizationsService: OrganizationsService,
              private organizationTypesService: OrganizationTypesService,
              public authGuard: AuthGuard,
              private readonly i18n: TranslocoService
  ) {
    this.currentFilters = new AnalysisCompaniesFilters();
  }

  ngOnInit(): void {
    this.language = this.i18n.getActiveLang();

    this.hierarchy = Array.from({length: 10}, () => {
      return {
        children: [],
        data: {},
        expanded: true,
        label: '',
        parent: null
      }
    })
    this.loadHierarchyList();
    this.loadFilters();
  }

  private loadFilters(): void {
    this.organizationTypesService.getOrganizationTypes().subscribe(response => {
      this.organizationTypes = response.organizationTypes;
    });
  }

  private loadHierarchyList(): void {
    this.loadingCompanies = true;
    this.organizationsService.getOrganizations()
      .subscribe(response => {
        let responseTreeNode = this.hierarchyService.getHierarchyListTreeNode(response.hierarchyListDto);
        this.nodes = responseTreeNode[0];
        this.hierarchy = responseTreeNode[1];
        this.hierarchyFilters = responseTreeNode[2];
      }).add(() => {
      this.loadingCompanies = false;
    });
  }

  resetFilters(): void {
    this.currentFilters = new AnalysisCompaniesFilters();
    this.organizationParent = null;
  }

  applyFilters(): void {
    this.treeTable.filter(this.currentFilters.name?.trim(), 'name', 'contains');
    this.treeTable.filter(this.currentFilters.organizationTypesUuids, 'organizationType.organizationTypeUuid', 'in');
    this.treeTable.filter(this.currentFilters.parentUuid, 'parentUuid', 'is');
    this.filtersVisible = false;
  }

    public readonly ExportFileType = ExportFileType;
}
